import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  Select,
  MenuItem,
  FormLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Divider,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../redux/Slice/customerSlice";
import { fetchService } from "../../redux/Slice/serviceslice";
import { createPlan, fetchPlan, updatePlan } from "../../redux/Slice/planslice";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { clearMessage } from "../../redux/Slice/message";
import { fetchTemplates } from '../../redux/Slice/showcase/templateSlice';
import VerticalTabs from "../../components/tabs/VerticalTab";
import { setLoading } from "../../redux/Slice/loaderSlice";
import {fetchTags} from "../../redux/Slice/showcase/tagSlice";
import { fetchProductTemplates } from "../../redux/Slice/ProductTemplate";
import { fetchInspirationTemplates } from "../../redux/Slice/InspirationTemplate";


const Plan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = useSelector((state) => state.message);
  const { customers } = useSelector((state) => state.customer);
  const { services } = useSelector((state) => state.service);
  // const { templates } = useSelector((state) => state.template);
  const { tags:templateOption } =useSelector((state) => state.tag);
    const { quotes} = useSelector((state) => state.quote);
    const { Producttemplates} = useSelector((state) => state.productTemplate);
    const { Inspirationtemplates} = useSelector((state) => state.inspirationTemplate);

    const templateProduct = Producttemplates?.filter((temp) => temp.status);
    const templateInspiration = Inspirationtemplates?.filter((inspiration) => inspiration.status);

    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(15);



  

  const [modifyServices, setModifyServices] = useState([]);


  const [selectedTemplates, setSelectedTemplates] = useState([]);

  const [selectedProductTemplates, setSelectedProductTemplates] = useState([]);
  const [selectedInspirationTemplates, setSelectedInspirationTemplates] = useState([]);

  
  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])
  

  useEffect(() => {
    const params = {
      page: page,
      limit: rowsPerPage,
      searchTerm: searchTerm
    }
    dispatch(fetchCustomers(params));
    dispatch(fetchService());
    dispatch(fetchPlan());
    dispatch(fetchTemplates());
    dispatch(fetchTags())
    // dispatch(fetchProductTemplates());
    // dispatch(fetchInspirationTemplates());

  }, [dispatch]);

  const validationSchema = Yup.object().shape({
    customer: Yup.string().required("Customer is required"),
    planName: Yup.string().required("Plan name is required"),
    planPrice: Yup.number()
      .required("Plan price is required")
      .typeError("Price must be a number"),
  });
  

  const initialValues = {
    customer: "",
    planName: "",
    planPrice: "",
    expiredDays: "",
    showcaseTemplate:[],
    productTemplate: [],
    inspirationTemplate: [],
  };

const handleSubmit = (values, { resetForm }) => {

  const updatedPlanData = {
    name: values.planName,
    price: values.planPrice,
    expiredDays: values.expiredDays,
    services: modifyServices,
    customerId: values.customer,
    showcaseTemplate: selectedTemplates,
    productTemplate: selectedProductTemplates,
    inspirationTemplate: selectedInspirationTemplates,


  };
  dispatch(setLoading(true));
  dispatch(createPlan(updatedPlanData))
    .then(() => {
      navigate('/customerplans')
      resetForm(); 
      dispatch(setLoading(false))
    })
    .catch((error) => {
    console.error(error);
    dispatch(setLoading(false));
    });
};

  const templateOptions = quotes?.filter((quote) => quote.status);
  console.log("temp:",quotes)

  return (
    <Grid container spacing={2} style={{ padding: "20px", }}>
      <Grid item size={12}>
        <Typography variant="h4" gutterBottom>
          Customer Plan Creation
        </Typography>
      </Grid>
      <Grid item size={12}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, setFieldValue }) => (
          <Form>
        <Grid container spacing={2}>
            {/* Customer Selection */}
            <Grid item size={3}>
              <FormControl fullWidth margin="normal">
                <FormLabel>Customer</FormLabel>
                <Select
                  name="customer"
                  value={values.customer}
                  onChange={handleChange}
                  error={touched.customer && Boolean(errors.customer)}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select Customer</MenuItem>
                  {customers.map((customer) => (
                    <MenuItem key={customer._id} value={customer._id}>
                      {customer.companyName}
                    </MenuItem>
                  ))}
                </Select>
                {touched.customer && errors.customer && (
                  <Typography color="error" variant="caption">
                    {errors.customer}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            {/* Plan Name */}
            <Grid item size={3}>
              <FormControl fullWidth margin="normal">
                <FormLabel>Plan Name</FormLabel>
                <TextField
                placeholder="Plan Name"
                name="planName"
                value={values.planName}
                onChange={handleChange}
                fullWidth
                error={touched.planName && Boolean(errors.planName)}
                helperText={touched.planName && errors.planName}
              />
              </FormControl>
            </Grid>

                        {/* Plan Name */}
                        <Grid item size={3}>
              <FormControl fullWidth margin="normal">
                <FormLabel>Plan Price</FormLabel>
                <TextField
                placeholder="Plan Price"
                name="planPrice"
                type="number"
                value={values.planPrice}
                onChange={handleChange}
                fullWidth
                error={touched.planPrice && Boolean(errors.planPrice)}
                helperText={touched.planPrice && errors.planPrice}
              />
              </FormControl>
            </Grid>

                                  {/* Plan Name */}
                                  <Grid item size={3}>
              <FormControl fullWidth margin="normal">
                <FormLabel>Expiration Days</FormLabel>
                <TextField
                placeholder="No of Days"
                name="expiredDays"
                value={values.expiredDays}
                onChange={handleChange}
                fullWidth
                error={touched.expiredDays && Boolean(errors.expiredDays)}
                helperText={touched.expiredDays && errors.expiredDays}
              />
              </FormControl>
            </Grid>

            {/* Plan Services with Features */}
            <Grid item size={12} >
            <Typography variant="h6">Features</Typography>
            </Grid>
            <Grid item size={12} >
              <VerticalTabs templateOptions={templateOptions} modifyServices={modifyServices} setModifyServices={setModifyServices} setFieldValue={setFieldValue} values={values} services={services}/>
            </Grid>
            <Grid item size={12}>
            <Divider/>

            </Grid>



{/* 
            <Grid item size={12}>
  <Typography variant="h6" gutterBottom>
    Showcase Templates
  </Typography>
  <FormControl component="fieldset" fullWidth>
    <Grid container direction="row" spacing={1}>
      {templateOption.map((template) => (
        <Grid item key={template._id}>
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedTemplates.includes(template._id)}
                onChange={(e) => {
                  const value = template._id;
                  if (e.target.checked) {
                    setSelectedTemplates([...selectedTemplates, value]);
                  } else {
                    setSelectedTemplates(selectedTemplates.filter((id) => id !== value));
                  }
                }}
                name="showcaseTemplates"
              />
            }
            label={template.name}
          />
        </Grid>
      ))}
    </Grid>
  </FormControl>
</Grid> */}


<Grid item size={12}>
                  <Typography variant="h6" gutterBottom>
                    Product Templates
                  </Typography>
                  <FormControl component="fieldset" fullWidth>
                    <Grid container direction="row" spacing={1}>
                      {templateProduct.map((template) => (
                        <Grid item key={template._id}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedProductTemplates.includes(template._id)}
                                onChange={(e) => {
                                  const value = template._id;
                                  if (e.target.checked) {
                                    setSelectedProductTemplates([...selectedProductTemplates, value]);
                                  } else {
                                    setSelectedProductTemplates(selectedProductTemplates.filter((id) => id !== value));
                                  }
                                }}
                                name="productTemplates"
                              />
                            }
                            label={template.templateName}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </FormControl>
                </Grid>

                {/* Inspiration Templates */}
                <Grid item size={12}>
                  <Typography variant="h6" gutterBottom>
                    Inspiration Templates
                  </Typography>
                  <FormControl component="fieldset" fullWidth>
                    <Grid container direction="row" spacing={1}>
                      {templateInspiration.map((template) => (
                        <Grid item key={template._id}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedInspirationTemplates.includes(template._id)}
                                onChange={(e) => {
                                  const value = template._id;
                                  if (e.target.checked) {
                                    setSelectedInspirationTemplates([...selectedInspirationTemplates, value]);
                                  } else {
                                    setSelectedInspirationTemplates(selectedInspirationTemplates.filter((id) => id !== value));
                                  }
                                }}
                                name="inspirationTemplates"
                              />
                            }
                            label={template.templateName}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </FormControl>
                </Grid>


           
            <Grid item size={12} display={'flex'} justifyContent={'end'}>
              <Button type="submit" variant="contained" color="primary">
                Save Plan
              </Button>
            </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      </Grid>
    </Grid>
  );
};

export default Plan;
